import { Paper, styled, Tab, Tabs } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { Grid } from '@mui/system';
import { ITheme } from 'theme/types';

export const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    navigation: {
      backgroundColor: theme.palette.primary[600],
      overflowX: 'hidden',
    },
    container: {
      margin: 0,
      padding: `0px ${theme.spacing(2)}px`,
      // width: '100%',
    },
    tabsContainer: {
      padding: '0px !important',
    },
    tabsItems: {
      // '& div[role="tablist"]': {
      //   overflowX: 'scroll'
      // },
    },
    tabItem: {
      color: '#80A4C5',
      fontSize: '12px',
      fontWeight: 600,
      minWidth: 0,
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,

      '&:hover': {
        color: theme.palette.white,
      },
    },
    selected: {
      color: theme.palette.white,
    },
    navChildren: {},
  })
);

export const NavigationPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: (theme as unknown as ITheme).palette.primary['600'],
  overflowX: 'hidden',
}));

export const Container = styled(Grid)(({ theme }) => ({
  margin: 0,
  padding: `0px ${theme.spacing(2)}`,
}));

export const TabsContainer = styled(Grid)({
  padding: '0px !important',
});

export const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

export const StyledTab = styled(Tab)(({ theme }) => ({
  color: '#80A4C5',
  fontSize: '12px',
  fontWeight: 600,
  minWidth: 0,
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,

  '&:hover': {
    color: (theme as unknown as ITheme).palette.white,
  },

  '&.Mui-selected': {
    color: `${(theme as unknown as ITheme).palette.white} !important`,
    '&::after': {
      transform: 'scaleX(1)',
    },
  },

  '&::after': {
    content: '""',
    height: '3px',
    backgroundColor: theme.palette.primary.main,
    width: '100%',
    position: 'absolute',
    bottom: 0,
    left: 0,
    transform: 'scaleX(0)',
    transformOrigin: 'left',
    transition: 'transform 200ms ease',
  },
}));

export const NavChildren = styled(Grid)({
  marginBottom: '12px',
  marginRight: '12px',
});

